import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-brand-cream paper-grain flex flex-col">
      <Header />
      <main className="flex-1 mx-auto max-w-3xl px-5 sm:px-8 py-16">
        <span className="eyebrow">Legal</span>
        <h1 className="mt-3 font-serif text-4xl text-brand-ink">Privacy Notice</h1>
        <div className="mt-8 space-y-6 text-sm text-brand-stone leading-relaxed">
          <p>Equitas Home Value (value.equitashomes.com) is operated by Equitas Homes. This notice explains what we collect and how we use it.</p>
          <Section title="What we collect">You may view a home value estimate, comparable sales, and a seller net sheet without providing any personal information. When you request a downloadable PDF report, we collect your name and email, and optionally your phone number.</Section>
          <Section title="Report delivery vs. marketing">Requesting a report does not enroll you in marketing. Optional marketing communications require your separate, affirmative consent, which you may withdraw at any time.</Section>
          <Section title="How we use your information">We use your contact details to deliver your report and, if you request it, to provide a broker-reviewed valuation. We do not sell your personal information.</Section>
          <Section title="Data retention">Report requests and associated contact information are retained for as long as needed to provide our services and to meet legal and business record-keeping requirements, after which they are deleted or anonymized.</Section>
          <Section title="Security">Provider API keys are kept server-side. Report downloads use private, expiring links and are not exposed through predictable public URLs.</Section>
          <Section title="Contact">Louis Fong, Broker, Equitas Homes · CA DRE #01151598 · (408) 561-1321 · louis@equitashomes.com</Section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
const Section = ({ title, children }) => (
  <div><h2 className="font-serif text-xl text-brand-ink">{title}</h2><p className="mt-2">{children}</p></div>
);
